import {
  RangeSearchParams,
  SearchAutocomplete,
  SearchAutocompleteChip,
  SearchParams,
  SearchType,
  ValuesSearchParams,
} from '../../types';

/**
 * Not all chips that we currently receive from the database are mapped in our front-end.
 * The currently used types are: train, rollingStock, rollingStockType, omloop.
 * Other types should be defined, but not yet implemented and therefor get searchType 'empty' (for now),
 * but don't forget to filter them out if you dont want to show them.
 *
 * @param chip
 * @returns
 */
export const mapChipToSearchType = (chip: SearchAutocompleteChip): SearchType => {
  const types: { [key: string]: SearchType } = {
    TREIN: 'train',
    EENHEID: 'rollingStock',
    MATERIEELTYPE: 'rollingStockType',
    OMLOOP: 'omloop',
    CLAIMSOORT: 'claimsoort',
    BIJZONDERHEIDSCODE: 'bijzonderheidscode',
  };
  return types?.[chip as keyof typeof types] ?? 'train';
};

/**
 * Filter incoming searchAutocomplete requests.
 * @param suggestion
 * @param filterBySearchType
 * @returns the Callback that can be passed to the filter.
 */
export const filterSearchAutocompleteSuggestions = (
  filterBySearchType: SearchType[] = [],
): ((suggestion: SearchAutocomplete) => boolean) => {
  return (suggestion: SearchAutocomplete) => {
    const isAllowedSearchType = [
      'TREIN',
      'EENHEID',
      'MATERIEELTYPE',
      'OMLOOP',
      'CLAIMSOORT',
      'BIJZONDERHEIDSCODE',
    ].includes(suggestion.chip);
    const isRequestedSearchType = Boolean(
      !filterBySearchType.length ||
      (filterBySearchType.length && filterBySearchType.includes(mapChipToSearchType(suggestion.chip))),
    );
    return isAllowedSearchType && isRequestedSearchType;
  };
};

/**
 * Sort a list of autocomplete suggestions on relevance
 * Basic rules are:
 * - Ranges on top.
 *
 */
export const sortAutocompleteByRelevance = (a: SearchAutocomplete, b: SearchAutocomplete) => {
  const hasRange = [true, false];
  const [aRange, bRange] = [hasRange.indexOf(Boolean(a.tot && a.van)), hasRange.indexOf(Boolean(b.tot && b.van))];
  if (aRange - bRange !== 0) return aRange - bRange;
  return String(a.waarde).localeCompare(String(b.waarde));
};

export const mapAutocompleteToSearchParams = (auto: SearchAutocomplete): SearchParams => {
  const params: Partial<SearchParams> = {
    searchModality: auto.waarde ? 'single' : 'range',
    searchType: mapChipToSearchType(auto.chip),
  };
  if (auto.waarde) {
    if (String(auto.waarde).includes(',')) {
      params.searchModality = 'multiple';
      (params as ValuesSearchParams).searchValue = String(auto.waarde).split(',');
    } else (params as ValuesSearchParams).searchValue = auto.waarde;
  }
  if (![auto.van, auto.tot].includes(null)) {
    params.searchModality = 'range'; // to be sure
    (params as RangeSearchParams).fromValue = auto.van as number;
    (params as RangeSearchParams).toValue = auto.tot as number;
  }
  return params as SearchParams;
};

// NOTE als we autoSearchComplete resultaat van de api naar SearchParams omzetten hoeft dit allemaal niet
// const mapChipToSearchField = (chip: SearchAutocompleteChip): SearchField => {
//   if (chip === 'EENHEID') return 'eenheid.nummer';
// }
// export const mapAutocompleteToCriteria = (auto: SearchAutocomplete): SearchRequest => {
//   const request = {
//     criteria: [{
//       veld:
//     }],
//   };
// };
